// extracted by mini-css-extract-plugin
export default {"sort_wrapper":"SortCaret_sort_wrapper__jwQtQ","caret":"SortCaret_caret__xZN8D","caret_up":"SortCaret_caret_up__NW3jj"};